import * as React from "react";
import { Input as DSInput } from "@/design-system/components";

import { cn } from "./utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <DSInput
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground/90 selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "aria-invalid:ring-destructive/20 aria-invalid:border-destructive/60",
        className,
      )}
      {...props}
    />
  );
}

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "placeholder:text-muted-foreground/90 selection:bg-primary selection:text-primary-foreground border border-border flex min-h-[120px] w-full rounded-[12px] px-4 py-3 text-[17px] bg-card transition-[color,box-shadow,border-color] duration-150 ease-out outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 resize-vertical focus-visible:ring-2 focus-visible:ring-primary",
        "aria-invalid:ring-destructive/20 aria-invalid:border-destructive/60",
        className,
      )}
      {...props}
    />
  );
}

export { Input, Textarea };